var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496.959 147.226c8.284 0 15-6.716 15-15v-117.226c0-8.284-6.716-15-15-15h-481.918c-8.284 0-15 6.716-15 15v117.226c0 8.284 6.716 15 15 15h46.386v35.162h-46.386c-8.284 0-15 6.716-15 15v117.226c0 8.284 6.716 15 15 15h46.386v35.162h-46.386c-8.284 0-15 6.716-15 15v117.224c0 8.284 6.716 15 15 15h481.918c8.284 0 15-6.716 15-15v-117.226c0-8.284-6.716-15-15-15h-46.304v-35.162h46.304c8.284 0 15-6.716 15-15v-117.225c0-8.284-6.716-15-15-15h-46.304v-35.162h46.304zm-466.918-117.226h451.918v87.226h-451.918zm451.918 452h-451.918v-87.226h451.918zm-61.304-117.226h-329.228v-35.162h329.228zm61.304-65.161h-451.918v-87.226h451.918zm-61.304-117.226h-329.228v-35.162h329.228z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.156 421.349c-6.727.85-12.16 6.279-13.008 13.006-1.245 9.875 7.066 18.179 16.948 16.93 6.727-.85 12.16-6.279 13.008-13.006 1.246-9.875-7.066-18.179-16.948-16.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.339 434.354c-1.245 9.875 7.066 18.179 16.948 16.93 6.727-.85 12.16-6.279 13.008-13.006 1.245-9.875-7.066-18.179-16.948-16.93-6.727.851-12.16 6.28-13.008 13.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.156 241.032c-6.727.85-12.16 6.279-13.008 13.006-1.245 9.875 7.066 18.179 16.948 16.93 6.727-.85 12.16-6.279 13.008-13.006 1.246-9.875-7.066-18.179-16.948-16.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.339 254.038c-1.245 9.875 7.066 18.179 16.948 16.93 6.727-.85 12.16-6.279 13.008-13.006 1.245-9.875-7.066-18.179-16.948-16.93-6.727.85-12.16 6.279-13.008 13.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.096 90.651c6.727-.85 12.16-6.279 13.008-13.006 1.245-9.875-7.066-18.179-16.948-16.93-6.727.85-12.16 6.279-13.008 13.006-1.245 9.875 7.067 18.179 16.948 16.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.287 90.651c6.727-.85 12.16-6.279 13.008-13.006 1.245-9.875-7.066-18.179-16.948-16.93-6.727.85-12.16 6.279-13.008 13.006-1.246 9.875 7.066 18.179 16.948 16.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.067 88.613c8.284 0 15-6.716 15-15s-6.716-15-15-15h-95.64c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.067 241h-95.64c-8.284 0-15 6.716-15 15s6.716 15 15 15h95.64c8.284 0 15-6.716 15-15s-6.715-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.067 423.387h-95.64c-8.284 0-15 6.716-15 15s6.716 15 15 15h95.64c8.284 0 15-6.716 15-15s-6.715-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServers);
export default __webpack_public_path__ + "static/media/servers.151809f29518f079140fffb84cb5123b.svg";
export { ForwardRef as ReactComponent };